import { render, staticRenderFns } from "./UpdatePatientInfoModal.vue?vue&type=template&id=61c32832&"
import script from "./UpdatePatientInfoModal.vue?vue&type=script&lang=ts&"
export * from "./UpdatePatientInfoModal.vue?vue&type=script&lang=ts&"
import style0 from "./UpdatePatientInfoModal.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports